import { render, staticRenderFns } from "./ModalCadastroEvento.vue?vue&type=template&id=6a6d4598"
import script from "./ModalCadastroEvento.vue?vue&type=script&lang=js"
export * from "./ModalCadastroEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports